module.exports = __webpack_public_path__ + "static/media/image-2.0687e774.png";